import React, {useEffect, useRef} from 'react';
import styles from './vtrg_custom_html.scss';
import InnerHTML from 'dangerously-set-html-content';
import gsap from 'gsap';

import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const VtrgCustomHtml = ({ data, slot }) => {
  const vtrgCustomHtmlBlock = useRef();
  const result = data && data.body;
  const VtrgEditMode = window.location.pathname.includes("/edit");

  useEffect(() => {
    let ctx = gsap.context(() => {  
      const img = vtrgCustomHtmlBlock.current?.querySelector(".horizontal-content__img");
    
      if (VtrgEditMode || !img) return;

      gsap.to(".horizontal-content__img", {
            x: () => window.innerWidth - img.clientWidth,
            ease: "none",
            scrollTrigger: {
              trigger: ".horizontal-content",
              start: "top top",
              scrub: true,
              pin: true,
              invalidateOnRefresh: true,
              anticipatePin: 1,
            }
      });
    }, vtrgCustomHtmlBlock);
    
    return () => {
      ScrollTrigger.kill();

      ctx.revert();
    }
  }, []);

  useEffect(() => {
    const videos = vtrgCustomHtmlBlock.current ? vtrgCustomHtmlBlock.current.querySelectorAll('video.autoplay-scroll') : [];
    const handleScroll = () => {
      const scrollY = window.pageYOffset;
      const pointYTop = vtrgCustomHtmlBlock.current ? vtrgCustomHtmlBlock.current.getBoundingClientRect().top : 0;
      const pointYBottom = vtrgCustomHtmlBlock.current ? vtrgCustomHtmlBlock.current.getBoundingClientRect().bottom : 0;
      if (videos.length > 0) {
        if (pointYTop <=  window.innerHeight && pointYBottom >= 0 && scrollY > 0) {
          videos.forEach(video => { 
            video.play();
          });
        } else {
          videos.forEach(video => { 
            video.pause();
          });
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };

  }, []);

  return (<>
    {data && data.body && <div data-slot={slot} ref={vtrgCustomHtmlBlock} style={ {marginTop:"-1px", marginBottom:"-1px", lineHeight: 0 } }>
                            <InnerHTML html={result} />
                          </div>}
  </>)
};

export default VtrgCustomHtml;